


export class ViewPoIntegMySuporte {
  "PO";
  "POItem";
  "VendorName";
  "MaterialDescription";
  "QtyOrdered";
  "UnitPrice";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewPoIntegMySuporte`.
   */
  static getModelName() {
    return "ViewPoIntegMySuporte";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ViewPoIntegMySuporte for dynamic purposes.
  **/
  static factory(data) {
    return new ViewPoIntegMySuporte(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ViewPoIntegMySuporte',
      plural: 'ViewPoIntegMySuportes',
      path: 'ViewPoIntegMySuportes',
      properties: {
        "PO": {
          name: 'PO',
          type: 'string'
        },
        "POItem": {
          name: 'POItem',
          type: 'string'
        },
        "VendorName": {
          name: 'VendorName',
          type: 'string'
        },
        "MaterialDescription": {
          name: 'MaterialDescription',
          type: 'string'
        },
        "QtyOrdered": {
          name: 'QtyOrdered',
          type: 'number'
        },
        "UnitPrice": {
          name: 'UnitPrice',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ViewPoIntegMySuporte.js